import Swiper from "swiper";
import 'swiper/css';

export default class PushActs {
  static init() {
    document.querySelectorAll(".push-actualites__swiper").forEach((el) => {
      new Swiper(el, {
        slidesPerView: "auto",
        spaceBetween: 20,
        grabCursor: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          1024: {
            slidesPerView: 3,
          },
        },
      });
    });
  }
}